module.exports = __webpack_public_path__ + "img/female-avatar.0f059e4a.png";